import React from 'react'
import PropTypes from 'prop-types'

import createEffectAction from 'coact/pages/modules/pageAction/createEffectAction'

import FormEditor from 'coact/editors/FormEditor'
import TableEditor from 'coact/editors/TableEditor'

import InvoiceTable from '~/src/components/InvoiceTable/index.js'

const { object, func } = PropTypes

function RecStatementEditor(props) {
  const {
    page: { schema, ui },
    dispatch,
  } = props

  const invalidInvoice = id =>
    dispatch(createEffectAction({ name: 'invalidInvoice', id }))

  return (
    <React.Fragment>
      <link
        href="https://fonts.googleapis.com/css?family=Libre+Barcode+39&display=swap"
        rel="stylesheet"
      />
      <FormEditor ui={ui.form} schema={schema} />
      <TableEditor ui={ui.recItems} schema={schema} />
      <InvoiceTable ui={ui.invoices} invalidInvoice={invalidInvoice} />
      <div
        style={{
          fontFamily: "'Libre Barcode 39', cursive",
          fontSize: 1,
          color: 'white',
        }}
      >
        *font*
      </div>
      <div>
        <img
          style={{ width: 1, height: 1 }}
          src="invoiceLogo.png"
          alt="禾宏文化"
        />
      </div>
    </React.Fragment>
  )
}

RecStatementEditor.propTypes = {
  page: object.isRequired,
  dispatch: func.isRequired,
}

export default RecStatementEditor
